import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useSubscriptionPlanList = (params?: any) => {
  return useQuery({
    queryKey: ['subscription-plan-list', params],
    queryFn: async () => {
      const res = await request.get('/subscription-plan', { params });
      return res.data;
    }
  });
};
